<script lang="ts">
	import {CopyCommand} from '$lib/core/ui/copy-command';
</script>

<!-- Use It Section -->
<div class="mb-4 text-center">
	<p class="mb-2 text-sm text-muted-foreground">Use it:</p>
	<CopyCommand command="pnpm create jolly-roger my-app" />
</div>

<p class="text-sm text-muted-foreground">
	Find out more on
	<a
		href="https://github.com/wighawag/jolly-roger"
		target="_blank"
		rel="noopener noreferrer"
		class="underline hover:text-foreground"
	>
		github
	</a>
</p>
